export default __webpack_public_path__ + "static/media/button talkback-11.a186a254.png";